// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__23WX6","colMin":"styles_colMin__3DOGK","colCheckbox":"styles_colCheckbox__bTe5N"};